// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3w6C1","addWidgetButton":"Header_addWidgetButton__2yN3y","dashboardTabs":"Header_dashboardTabs__3--oX","active":"Header_active__3TElW"};